import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=4281e715"
var script = {}
import style0 from "./Documentation.vue?vue&type=style&index=0&id=4281e715&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_css-loader@6.11.0_webpack@5.108.4_postcss@8_625ca5ec83f73082d4f0758ff79d525c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports